import { createSelector } from 'reselect'

export const getLists = (state, props) => {
  return state['view-myboard'].view.lists
}

export const getListsById = (state, props) => {
  return state['view-myboard'].lists
}

export const makeListsSelector = () => createSelector(
  [getLists, getListsById],
  (lists, listsById) =>
    lists
      .map(id => listsById[id])
      .sort((a, b) => a.position - b.position)
)

export const listsSelector = makeListsSelector()
